var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmergency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12879_36087)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#FF5961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 4H7C3.13401 4 0 7.13401 0 11V17C0 20.866 3.13401 24 7 24H21C24.866 24 28 20.866 28 17V11C28 7.13401 24.866 4 21 4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 3.5H2.33333C1.05 3.5 0 4.55 0 5.83333V22.1667C0 23.45 1.05 24.5 2.33333 24.5H25.6667C26.95 24.5 27.9883 23.45 27.9883 22.1667L28 5.83333C28 4.55 26.95 3.5 25.6667 3.5ZM10.5 9.33333C12.425 9.33333 14 10.9083 14 12.8333C14 14.7583 12.425 16.3333 10.5 16.3333C8.575 16.3333 7 14.7583 7 12.8333C7 10.9083 8.575 9.33333 10.5 9.33333ZM2.42667 22.1667C4.03667 19.3783 7.04667 17.5 10.5 17.5C13.9533 17.5 16.9633 19.3783 18.5733 22.1667H2.42667ZM24.465 11.4917L23.59 13.0083L21.875 12.0167V14H20.125V12.0167L18.41 13.0083L17.535 11.4917L19.25 10.5L17.535 9.50833L18.41 7.99167L20.125 8.98333V7H21.875V8.98333L23.59 7.99167L24.465 9.50833L22.75 10.5L24.465 11.4917Z",
    fill: "#FF5961"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12879_36087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/emergency.7c99ac6a99daa7e660835897e9f88d0d.svg";
export { ForwardRef as ReactComponent };